<template>
  <div v-if="isReviewer&&course" class="restricted-alert">
    <div class="floating-alert-status show">
      <div class="container">
        <div class="page-alert mb-0" :class="isUnpublished ? 'warning' : 'info'">
          <i class="page-alert__icon far fa-exclamation-circle"></i>
          <b>
          <span v-if="isUnpublished"><b>Reviewing restricted course version (unavailable to public)</b></span>
          <span v-else><b>Viewing publicly available course version</b></span>
          <span v-if="includeDraftVersions && course.isActive"> with proposed Units/Unit Sets</span>
          </b>
          <div class="float-right">
            <div v-if="course.isWhitelisted" class="badge badge-success">Enabled for Course Visualiser</div>
            <div v-else class="badge badge-danger">Not enabled for Course Visualiser</div>
            <div v-if="!course.isActive" class="badge badge-primary">{{statusLabel(course.status)}}</div>
            <div v-else-if="includeDraftVersions" class="badge badge-info">Including Proposed Units</div>
            <div class="badge badge-secondary">Version {{course.courseLoopVersionNumber}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      course: 'courses/getSelectedCourse',
      isUnpublished: 'courses/isUnpublished',
      isReviewer: 'global/isReviewer',
      isAuthenticated: 'global/isAuthenticated',
      includeDraftVersions: 'courses/includeDraftVersions'
    })
  },
  methods: {
    statusLabel(id) {
      return this.__(`label:status ${id.toLowerCase()}`)
    }
  },
  mounted() { }
}
</script>

<style></style>
